import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-alpha-linkbar',
    templateUrl: './alpha-linkbar.component.html',
    styleUrls: ['./alpha-linkbar.component.scss'],
    standalone: false
})
export class AlphaLinkbarComponent implements OnInit {
  @Output() selectionEmitter = new EventEmitter<string>();
  @Input() outputFromChild: any[];

  public numeroAlpha: any[] = [
      { 'name': '#' },
      { 'name': 'A' },
      { 'name': 'B' },
      { 'name': 'C' },
      { 'name': 'D' },
      { 'name': 'E' },
      { 'name': 'F' },
      { 'name': 'G' },
      { 'name': 'H' },
      { 'name': 'I' },
      { 'name': 'J' },
      { 'name': 'K' },
      { 'name': 'L' },
      { 'name': 'M' },
      { 'name': 'N' },
      { 'name': 'O' },
      { 'name': 'P' },
      { 'name': 'Q' },
      { 'name': 'R' },
      { 'name': 'S' },
      { 'name': 'T' },
      { 'name': 'U' },
      { 'name': 'V' },
      { 'name': 'W' },
      { 'name': 'X' },
      { 'name': 'Y' },
      { 'name': 'Z' }
  ];
  activeIndex: number;

  constructor() { }

  ngOnInit(): void {
    this.activeIndex = 0;
  }

  ngAfterContentChecked() {

    if (this.outputFromChild) {
      for (let i = 0; i < this.outputFromChild.length; i++) {
        // this.numeroAlpha.filter((data) => data.name == this.outputFromChild[i])[0].editable = true;
        // (document.getElementById('myBtn') as HTMLElement). = "pointer-events: none;";
        document.getElementById(this.outputFromChild[i])?.classList.add('activeclass');
        document.getElementById(this.outputFromChild[i])?.classList.remove('notactiveclass');
      }
      document.getElementById("#")?.classList.add('activeclass');
      document.getElementById("#")?.classList.remove('notactiveclass');
    } else {
      for (let i = 0; i < this.numeroAlpha.length; i++) {
        document.getElementById(this.numeroAlpha[i].name)?.classList.add('activeclass');
        document.getElementById(this.numeroAlpha[i].name)?.classList.remove('notactiveclass');
      }
    }
  }
  update(outputFromChild: any){
    for (let i = 0; i < this.numeroAlpha.length; i++) {
      document.getElementById(this.numeroAlpha[i].name)?.classList.remove('activeclass');
      document.getElementById(this.numeroAlpha[i].name)?.classList.add('notactiveclass');
    }
      for (let i = 0; i < outputFromChild.length; i++) {
        // this.numeroAlpha.filter((data) => data.name == this.outputFromChild[i])[0].editable = true;
        // (document.getElementById('myBtn') as HTMLElement). = "pointer-events: none;";
        document.getElementById(outputFromChild[i])?.classList.add('activeclass');
        document.getElementById(outputFromChild[i])?.classList.remove('notactiveclass');
      }
      document.getElementById("#")?.classList.add('activeclass');
      document.getElementById("#")?.classList.remove('notactiveclass');
    
  }
  selectNumeroAlpha(linkIndex: number) {
    // console.log('user selected: ', this.numeroAlpha[linkIndex]);
    this.activeIndex = linkIndex;
    this.selectionEmitter.emit(this.numeroAlpha[linkIndex].name);
  }

  setActiveIndexByNumeroAlpha(value: string) {
    this.activeIndex = this.numeroAlpha.indexOf(value);
  }

  parrentEventHandlerFunction(arrayList: any[]) {
    console.log(arrayList);
  }

  resetNumeroAlpha() {
    this.numeroAlpha = [
      { 'name': '#' },
      { 'name': 'A' },
      { 'name': 'B' },
      { 'name': 'C' },
      { 'name': 'D' },
      { 'name': 'E' },
      { 'name': 'F' },
      { 'name': 'G' },
      { 'name': 'H' },
      { 'name': 'I' },
      { 'name': 'J' },
      { 'name': 'K' },
      { 'name': 'L' },
      { 'name': 'M' },
      { 'name': 'N' },
      { 'name': 'O' },
      { 'name': 'P' },
      { 'name': 'Q' },
      { 'name': 'R' },
      { 'name': 'S' },
      { 'name': 'T' },
      { 'name': 'U' },
      { 'name': 'V' },
      { 'name': 'W' },
      { 'name': 'X' },
      { 'name': 'Y' },
      { 'name': 'Z' }
    ];
  }

}
